import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Grid, Modal, Input } from '../../components/index';
import {
  doPut,
  trataMensagemSucesso,
} from '../../utils/requests';

class ModalAlteracaoMotivoCessacao extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    motivoCessacaoManual: this.props.motivoCessacaoManual,
    touched: false,
  });

  checkIfFileCanBeSent = () => (this.state.motivoCessacaoManual || this.state.motivoCessacaoManual === '');

  diffRequerimento = () => {
    const { tipoRequerimento } = { ...this.props };
    if (tipoRequerimento === 2) {
      return 'pensao';
    }
    return 'aposentadoria';
  }

  handleSave = () => {
    const tipo = this.diffRequerimento();
    const url = `alterar-data-cessacao-requerimento-${tipo}`;
    const { protocolo } = { ...this.props };
    const { estadoFormulario } = { ...this.props };
    const { motivoCessacaoManual } = { ...this.state };
    const objProtocolo = protocolo;
    const objDataCessacaoBeneficio = estadoFormulario.requerimento.dataCessacaoBeneficio;
    // const objDataCessacaoBeneficio = '19/02/2026';
    let objMotivoCessacaoManual = motivoCessacaoManual;
    if (objMotivoCessacaoManual === '') {
      objMotivoCessacaoManual = null;
    }
    const objAlteracao = { protocolo: objProtocolo, motivoCessacaoManual: objMotivoCessacaoManual, dataCessacao: objDataCessacaoBeneficio };
    let options;
    if (this.state.chaveConfirmacao) {
      options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
    }
    doPut(
      url,
      objAlteracao,
      this.trataSucessoResponseEnvio,
      this.trataErrosResponse,
      options,
    );
  }

  trataSucessoResponseEnvio = (response) => {
    this.handleClose();
    this.props.atualizarMotivoCessacao(this.state.motivoCessacaoManual);
    // Adiciona o histórico para bloquear o lápis
    // const novoHistorico = {
    //   descricao: 'Informação de data e motivo de cessação',
    // };
    // console.log(response.data);
    const retorno = response && response.data ? response.data : [];

    this.props.atualizarHistoricoAuditorias(retorno);
    trataMensagemSucesso(['Motivo de cessação do benefício alterado']);
  }

  filterMotivos = (lista, requerimento, tipo) => {
    let motivosCessacaoFiltrado = [];
    const codigoTipo = tipo === 'aposentadoria' ? 1 : 2;
    const inss = '01000';
    let destinatarioOuSolicitanteRGPS = false;
    let regimes = [2, 3];

    if (requerimento.solicitante) {
      destinatarioOuSolicitanteRGPS = [requerimento.solicitante.codigo, requerimento.destinatario.codigo].includes(inss);
      if (requerimento.solicitante.codigo === inss) {
        regimes = [1, 3];
      }
    }
    const acordos = (destinatarioOuSolicitanteRGPS) ? [1, 3] : [2, 3];

    motivosCessacaoFiltrado = lista.filter(motivo => (
      motivo.abrangenciaAplicavel === codigoTipo &&
      regimes.includes(motivo.regimeAplicavel) &&
      acordos.includes(motivo.acordoAplicavel)
    ));

    return motivosCessacaoFiltrado;
  };

  modalContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="8 8 12 12">
          <Input
            label="Motivo Cessacão"
            number
            touched={this.props.estadoFormulario.touched}
            placeholder="Selecione o Motivo da Cessacão"
            onChange={e => this.handleChange(e, 'motivoCessacaoManual')}
            value={this.state.motivoCessacaoManual}
            itemList={this.filterMotivos(
                this.props.motivosCessacao,
                this.props.estadoFormulario.requerimento,
                'aposentadoria',
              )}
            required={this.props.estadoFormulario.requerimento.dataCessacaoBeneficio !== null}
            custom
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          className="dtp-primary"
          disabled={!this.checkIfFileCanBeSent()}
          hint="Salvar"
          onClick={this.handleSave}
          title="Salvar"
        />
      </div>
    </React.Fragment>
  )

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleClose = () => {
    this.setState({ motivoCessacaoManual: null }, this.props.handleModal('exibirModalMotivoCessacao'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="md"
        showModal={this.props.showModal}
        title="Alterar o motivo de cessação do requerimento"
      />
    );
  }
}

ModalAlteracaoMotivoCessacao.propTypes = {
  tipoRequerimento: PropTypes.number.isRequired,
  protocolo: PropTypes.string.isRequired,
  motivoCessacaoManual: PropTypes.string.isRequired,
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  atualizarMotivoCessacao: PropTypes.func,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
}.isRequired;

const mapStateToProps = state => ({
  motivosCessacao: state.base.motivosCessacao,
});

export default connect(mapStateToProps)(ModalAlteracaoMotivoCessacao);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ModalAlteracaoMotivoCessacao.jsx